/**
 * @author Nagarjuna Naidu <nagarjuna.naidu@siera.ai>
 *  SIERA DASHBOARD COUNT TYPES
 */

export const countStateTypes = {
  // 1. TYPE: COUNT LIST
  UPDATE_COUNT: "UPDATE_COUNT",
};
